import { useId, useState } from "react";
import { Icon } from "./Icon";
import { Dialog } from "./ui";

/** Share only the permalink; previews deliberately omit member identities. */
export function SharePost({ postId }: { postId: string }) {
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState("");
  const [busy, setBusy] = useState(false);
  const id = useId();
  const url = new URL(`/posts/${encodeURIComponent(postId)}`, window.location.origin).href;
  const copy = async () => {
    setBusy(true);
    try {
      if (!navigator.clipboard?.writeText) throw new Error("clipboard unavailable");
      await navigator.clipboard.writeText(url);
      setStatus("リンクをコピーしました。");
    } catch {
      setStatus("コピーできませんでした。下のリンクを選択してコピーしてください。");
    } finally { setBusy(false); }
  };
  const share = async () => {
    setBusy(true);
    try {
      await navigator.share({ title: "ここ好き · ほろりばレコード", url });
      setStatus("共有しました。");
    } catch (error) {
      if (!(error && typeof error === "object" && "name" in error && error.name === "AbortError")) setStatus("共有を開けませんでした。リンクのコピーをお試しください。");
    } finally { setBusy(false); }
  };
  return <>
    <button type="button" className="btn btn-secondary btn-small" onClick={() => { setStatus(""); setOpen(true); }}>
      <Icon name="link" className="btn-icon" />共有する
    </button>
    <Dialog open={open} onClose={() => setOpen(false)} title="この投稿を共有">
      <p>リンクを開けるのは、ほろりばのサーバーメンバーだけです。</p>
      <p className="muted">リンクのプレビューには、ここ好きの本文・曲名・歌唱者・時刻が表示されます。投稿者名やアイコンは表示されません。</p>
      <div className="share-post__actions">
        <button type="button" className="btn btn-primary" disabled={busy} onClick={() => void copy()}>リンクをコピー</button>
        {typeof navigator.share === "function" && <button type="button" className="btn btn-secondary" disabled={busy} onClick={() => void share()}>ほかのアプリで共有</button>}
      </div>
      <label className="field__label" htmlFor={id}>投稿のリンク</label>
      <input id={id} className="input share-post__url" readOnly value={url} onFocus={(e) => e.currentTarget.select()} />
      <p role="status" className="share-post__status">{status}</p>
    </Dialog>
  </>;
}
